import strataxArtifacts from "./Stratax.json";
import strataxPositionNftArtifacts from "./StrataxPositionNft.json";
import feeCollectorArtifacts from "./FeeCollector.json";
import StrataxTokenSaleArtifacts from "./StrataxTokenSale.json";

export const STRATAX_ABI = strataxArtifacts.abi;
export const STRATAX_POSITION_NFT_ABI = strataxPositionNftArtifacts.abi;
export const FEE_COLLECTOR_ABI = feeCollectorArtifacts.abi;
export const STRATAX_TOKEN_SALE_ABI = StrataxTokenSaleArtifacts.abi;

export const ERC20_ABI = [
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
];
